/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface PartnerModel {

        "personType"?: string;

        "documentNumber"?: number;

        "name"?: string;

        "birthday"?: Date;

        "rg"?: PartnerModelRg;
    }

}
